import React, { useState } from "react";
import LaibaPCOSLoveGuideApp from "./LaibaPCOSLoveGuideApp";
import AuthPage from "./AuthPage";
import PartnerDashboard from "./PartnerDashboard";
import { useAuth } from "./AuthContext";

function App() {
  const { user, profile, loading } = useAuth();
  const [viewLaibaPOV, setViewLaibaPOV] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-rose-100 via-pink-50 to-purple-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rose-500 mx-auto"></div>
          <p className="mt-4 text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <AuthPage />;
  }

  // Partner view: Only afshaank338@gmail.com can see Laiba's page
  const isPartner = user?.email === "afshaank338@gmail.com" || profile?.role === "partner";
  
  if (isPartner) {
    // If viewing Laiba's POV, show her main app
    if (viewLaibaPOV) {
      return <LaibaPCOSLoveGuideApp />;
    }
    
    // Otherwise show partner dashboard with POV toggle
    return (
      <PartnerDashboard 
        viewLaibaPOV={viewLaibaPOV} 
        setViewLaibaPOV={setViewLaibaPOV} 
      />
    );
  }

  return <LaibaPCOSLoveGuideApp />;
}

export default App;